import React from "react";
import { useTranslation } from "react-i18next";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import i18n from "i18next";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ToggleStatus, getNews } from "../redux/actionCreator";

function Header({ id }) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [langToggle, setLangtoggle] = useState("");
  const [language, setLanguage] = useState("en");
  const [news, setNews] = useState([]);
  let current = localStorage.getItem("lang");
  const haveNews = localStorage.getItem("newsCount")
  let body = document.body;
  const [repoStatus, setRepoStatus] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", "ar");
    }
    dispatch(ToggleStatus((status) => {
      setRepoStatus(status)
    }))
  }, []);

  useEffect(() => {
    const pathArray = location.pathname.split("/");
    if (pathArray?.length && pathArray?.includes("en")) {
      localStorage.setItem("lang", "en");
      setLanguage('en')
    } else {
      if (localStorage.getItem("lang")) {
        setLanguage(localStorage.getItem("lang"))
      } else {
        localStorage.setItem("lang", "ar");
        setLanguage('ar')
      }
    }

  }, [location.pathname])

  const openHeader = (e) => {
    e.preventDefault();
    body.classList.add("box-collapse-open");
    body.classList.remove("box-collapse-closed");
  };

  const closeHeader = (e) => {
    e.preventDefault();
    body.classList.remove("box-collapse-open");
    body.classList.add("box-collapse-closed");
  };
  useEffect(() => {
    // console.log(window?.location?.pathname);
    // if (window?.location?.pathname === "/") {
    //   navigate(`/en/`);
    // }
    const path = location.pathname.includes("/en");
    // console.log(path);
    if (path) {
      localStorage.setItem("lang", "en");
    }
    // else {
    //   localStorage.setItem("lang", "ar");
    // }
  }, []);

  // let luga = localStorage.getItem("lang");
  // useEffect(() => {
  //   // luga
  //   let currentlang = location.pathname.split('/')[1]
  //   navigate(location.pathname.replace(currentlang, luga))
  // }, [location.pathname])

  const chnageLan = (lang) => {
    setLangtoggle(!langToggle);
    localStorage.setItem("lang", lang);
    setLanguage(lang);

    if (lang === "ar") {
      document.body.className = "rtl";
    } else {
      document.body.className = "ltr";
    }
    let currentLanguage = lang == "en" ? "ar" : "en";
    // console.log(location.pathname.replace('/' + currentLanguage, '/' + lang));
    navigate(location.pathname.replace('/' + currentLanguage, '/' + lang));
    // if(location.pathname?.split("/")?.length === 1){
    //     navigate(`/en/`)
    // }else{
    //     navigate(`/${lang}/${location.pathname?.split("/")?.slice(-1)?.[0]}`)
    // }
  };

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  useEffect(() => {
    i18n.changeLanguage(current);
    if (current === "ar") {
      document.body.className = "rtl";
    } else {
      document.body.className = "ltr";
    }
  }, [current]);

  useEffect(() => {
    dispatch(getNews({}, (res) => {
      setNews(res.home)
    }))
  }, [])

  return (
    <>
      <div id="Header">
        <div className="click-closed" />
        <div className="box-collapse">
          <span
            className="close-box-collapse left-boxed fas fa-times"
            onClick={closeHeader}
          />
          <div className="box-collapse-wrap">
            <div className="container">
              <div className="navlink__items">
                <div className="row">
                  <ul>
                    <li onClick={closeHeader} className={window.location.pathname != `/${i18n.language}` ? 'home' : ''}>
                      <NavLink to={`/${i18n.language}`} rel="noreferrer"> {t("home")} </NavLink>
                    </li>
                    <li onClick={closeHeader}>
                      <NavLink to={`/${i18n.language}/about`} rel="noreferrer">{t("about")}</NavLink>
                    </li>
                    <li onClick={closeHeader}>
                      <NavLink to={`/${i18n.language}/assignments`} rel="noreferrer">
                        {t("roles")}
                      </NavLink>
                    </li>
                    <li onClick={closeHeader}>
                      <NavLink to={`/${i18n.language}/jurisdictions`} rel="noreferrer">
                        {t("jurisdictions")}
                      </NavLink>
                    </li>
                    {
                      news?.length > 0 &&
                      <li onClick={closeHeader}>
                        <NavLink to={`/${i18n.language}/news`} rel="noreferrer" >
                          {t("News")}
                        </NavLink>
                      </li>
                    }


                    <li onClick={closeHeader}>
                      <NavLink to={`/${i18n.language}/contact`} rel="noreferrer">
                        {t("contact")}
                      </NavLink>
                    </li>
                    {
                      repoStatus &&
                      <li>
                        <NavLink to={`/${i18n.language}/report_incident`} rel="noreferrer">
                          {" "}
                          <button className="report-incident" dir="ltr">
                            <img src="./assets/img/icons/Group 11799.svg" />
                            {t('report_incident')}
                          </button>
                        </NavLink>
                      </li>
                    }

                  </ul>
                  <div className="social__links">
                    <ul>
                      <li>
                        <a
                          href="https://www.instagram.com/escdubai/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/escdubai" target="_blank" rel="noreferrer">
                          {/* <i className="fab fa-twitter"></i> */}
                          {/* <i className = "fa-brands fa-x-twitter"></i> */}
                          <img src="./assets/img/socialIcons/x-twitter-white.svg" width={14} />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.linkedin.com/company/escdubai/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      {/* <li>
                        <a
                          href="https://www.facebook.com/ESCODXB"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <nav id="navbarHeader" className="navbar navbar-default navbar-trans navbar-expand-lg fixed-top">
          <div className="container navbar__border">
            <div className="logo__side">
              <Link className="navbar-brand" to={`/${i18n.language}`} rel="noreferrer">
                <img src="./assets/img/logo.svg" />{" "}
              </Link>
              <button
                type="button"
                className="navbar-toggle-box navbar-toggle-box-collapse"
                onClick={openHeader}
                data-bs-toggle="collapse"
                data-bs-target="#navbarTogglerDemo01"
              >
                <i className="fas fa-bars" />
              </button>
              <div className="social__links">
                <ul>
                  <li>
                    <a
                      href="https://www.instagram.com/escdubai/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/escdubai" target="_blank" rel="noreferrer">
                      {/* <i className="fab fa-twitter"></i> */}
                      {/* <i className = "fa-brands fa-x-twitter"></i> */}
                      <img src="./assets/img/socialIcons/x-twitter-white.svg" width={14} />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/escdubai/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  </li>
                  {/* <li>
                    <a href="https://www.facebook.com/ESCODXB" target="_blank" rel="noreferrer">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li> */}
                  {
                    repoStatus &&
                    <li>
                      <Link to={`/${i18n.language}/report_incident`} rel="noreferrer">
                        {" "}
                        <button className="report-incident">
                          <img src="./assets/img/icons/Group 11799.svg" />
                          {t('report_incident')}
                        </button>
                      </Link>
                    </li>
                  }

                </ul>
              </div>
            </div>

            <div className="language">
              {current == "en" ? (
                <div
                  className="language__switch"
                  onClick={() => chnageLan("ar")}
                >
                  <Link rel="noreferrer">ع</Link>
                </div>
              ) : (
                <div
                  className="language__switch"
                  onClick={() => chnageLan("en")}
                >
                  <Link rel="noreferrer">En</Link>
                </div>
              )}

              <Link
                className="navbar-brand economy__logo"
                to={`/${i18n.language}/`}
                rel="noreferrer"
              >
                <img src="./assets/img/right-logo.svg" />{" "}
              </Link>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Header;
